<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">Buat Customer Baru</h2>
      </div>
    </div>
    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <a-button @click="$router.back()"> <LeftOutlined />Back </a-button>
        </a-col>
        <a-col :span="24">
          <div>
            <h1 class="text-title">Customer</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">ID (4 HURUF)</p>
                <a-input
                  placeholder="Masukkan Id Customer"
                  v-model:value="payload.customerSign"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Organisasi</p>
                <a-select v-model:value="payload.organizationId" style="width: 100%;">
                  <a-select-option value="" disabled>Pilih Organisasi</a-select-option>
                  <a-select-option
                    v-for="(item, idx) in organizationList"
                    :key="idx"
                    :value="item.id"
                  >
                    {{ item?.name }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nama</p>
                <a-input
                  placeholder="Masukkan Nama Customer"
                  v-model:value="payload.name"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Email</p>
                <a-input
                  placeholder="Masukkan Email Customer"
                  v-model:value="payload.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Handphone</p>
                <a-input
                  placeholder="Masukkan Nomor Handphone"
                  v-model:value="payload.mobileNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Kantor</p>
                <a-input
                  placeholder="Masukkan Nomor Kantor"
                  v-model:value="payload.officeNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Penanggung Jawab</p>
                <a-input
                  placeholder="Masukkan Nama Penanggung Jawab"
                  v-model:value="payload.PIC"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Provinsi</p>
                <a-select
                  v-model:value="payload.provinsi"
                  style="width: 100%;"
                  show-search
                  placeholder="Pilih atau cari provinsi"
                  :filter-option="false"
                  @search="fetchProvinsi"
                  @blur="fetchProvinsi('')"
                >
                  <a-select-option value="" disabled>Pilih Provinsi</a-select-option>
                  <a-select-option
                    v-for="(prov, index) in filteredProvinces"
                    :key="index"
                    :value="prov"
                  >
                    {{ prov }}
                  </a-select-option>
                </a-select>
              </a-col>

              <a-col :xs="{ span: 24 }" :sm="{ span: 10 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Latitude</p>
                  <a-input
                    placeholder="Masukkan Latitude"
                    v-model:value="payload.latitude"
                    type="text"
                  ></a-input>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 10 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Longitude</p>
                  <a-input
                    placeholder="Masukkan Longitude"
                    v-model:value="payload.longitude"
                    type="text"
                  ></a-input>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 4 }">
                <div class="w-100">
                  <p class="text-label" style="opacity: 0;">.</p>
                  <a-button @click="searchCoordinatesOnMap" type="primary" style="width: 100%;">
                    Cari
                  </a-button>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 24 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Alamat</p>
                  <a-textarea
                    placeholder="Masukkan Alamat Customer (atau pilih dari peta)"
                    allow-clear
                    v-model:value="payload.address"
                  ></a-textarea>
                  <a-input-search
                    placeholder="Cari alamat di peta (contoh: Jl. Sudirman No. 1 Jakarta)"
                    enter-button="Cari"
                    @search="searchAddressOnMap"
                    class="mt-2"
                  />
                  <div
                    id="mapContainer"
                    style="height: 400px; width: 100%; margin-top: 10px; border-radius: 8px; overflow: hidden;"
                  ></div>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :span="18"></a-col>
            <a-col :span="6" class="d-flex justify-content-end align-items-center" style="gap:15px">
              <a-button @click="clearPayload()">Clear</a-button>
              <a-button @click="submitPayload()" type="primary">Submit</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { LeftOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { postCustomers } from '../../services/axios/modc/customer'
import { getOrganizations } from '../../services/axios/modc/organization'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: { LeftOutlined },
  setup() {
    const router = useRouter()
    // Payload sudah benar, memiliki latitude dan longitude
    const payload = ref({
      customerSign: '',
      name: '',
      email: '',
      mobileNumber: '',
      officeNumber: '',
      PIC: '',
      address: '',
      latitude: '',
      longitude: '',
      organizationId: '',
      provinsi: '',
    })

    const requiredFields = {
      customerSign: 'ID Customer',
      organizationId: 'Organisasi',
      name: 'Nama',
      email: 'Email',
      mobileNumber: 'Nomor Handphone',
      PIC: 'Penanggung Jawab',
      address: 'Alamat',
      latitude: 'Latitude Peta', // Latitude dan Longitude harus ada jika alamat dipilih dari peta
      longitude: 'Longitude Peta',
      provinsi: 'Provinsi',
    }

    const provinces = ref([
      'Aceh',
      'Sumatera Utara',
      'Sumatera Barat',
      'Riau',
      'Jambi',
      'Sumatera Selatan',
      'Bengkulu',
      'Lampung',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'DKI Jakarta',
      'Jawa Barat',
      'Jawa Tengah',
      'DI Yogyakarta',
      'Jawa Timur',
      'Banten',
      'Bali',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Kalimantan Barat',
      'Kalimantan Tengah',
      'Kalimantan Selatan',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Sulawesi Utara',
      'Sulawesi Tengah',
      'Sulawesi Selatan',
      'Sulawesi Tenggara',
      'Gorontalo',
      'Sulawesi Barat',
      'Maluku',
      'Maluku Utara',
      'Papua',
      'Papua Barat Daya',
      'Papua Barat',
      'Papua Selatan',
      'Papua Tengah',
      'Papua Pegunungan',
    ])
    const filteredProvinces = ref([])
    const organizationList = ref([])
    let map = null
    let marker = null

    onMounted(() => {
      nextTick(() => {
        try {
          map = L.map('mapContainer').setView([-6.2088, 106.8456], 13)
          fetchOrganization()
          filteredProvinces.value = [...provinces.value]
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          }).addTo(map)
          map.on('click', onMapClick)
        } catch (error) {
          console.log(error)
        }
      })
    })

    const fetchOrganization = async () => {
      const { organization } = await getOrganizations()
      organizationList.value = organization
    }

    const onMapClick = async e => {
      const { lat, lng } = e.latlng
      payload.value.latitude = lat
      payload.value.longitude = lng
      setMarker(lat, lng)
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=id`,
        )
        const data = await response.json()
        payload.value.address = data.display_name || `Koordinat: ${lat}, ${lng}`
      } catch (error) {
        notification.error({
          message: 'Error Geocoding',
          description: 'Gagal mendapatkan alamat dari koordinat.',
        })
        payload.value.address = `Koordinat: ${lat}, ${lng} (Gagal dapat alamat)`
      }
    }

    const setMarker = (lat, lng) => {
      if (marker) {
        marker.setLatLng([lat, lng])
      } else {
        marker = L.marker([lat, lng]).addTo(map)
      }
    }
    const isSearchingMap = ref(false)

    const searchAddressOnMap = async address => {
      if (!address) {
        notification.warn({
          message: 'Peringatan',
          description: 'Mohon masukkan alamat untuk mencari.',
        })
        return
      }
      isSearchingMap.value = true
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
            address,
          )}&accept-language=id`,
        )
        const data = await response.json()
        if (data && data.length > 0) {
          const { lat, lon, display_name } = data[0]
          payload.value.latitude = parseFloat(lat)
          payload.value.longitude = parseFloat(lon)
          payload.value.address = display_name
          setMarker(parseFloat(lat), parseFloat(lon))
          map.setView([parseFloat(lat), parseFloat(lon)], 16)
          notification.success({
            message: 'Alamat Ditemukan',
            description: `Menampilkan lokasi untuk: ${display_name}`,
          })
        } else {
          notification.error({ message: 'Alamat Tidak Ditemukan' })
        }
      } catch (error) {
        notification.error({
          message: 'Layanan Peta Gagal',
          description: 'Tidak dapat terhubung ke server peta. Mohon coba lagi nanti.',
        })
      } finally {
        isSearchingMap.value = false
      }
    }
    const searchCoordinatesOnMap = async () => {
      console.log('--- MEMBONGKAR INPUT ---')
      console.log('Isi mentah dari input Longitude:', payload.value.longitude)
      console.log('Tipe datanya:', typeof payload.value.longitude)
      console.log('Memulai searchCoordinatesOnMap...')
      isSearchingMap.value = true

      // Guard Clause untuk memastikan map sudah siap
      if (!map) {
        notification.error({
          message: 'Peta Belum Siap',
          description: 'Komponen peta belum selesai dimuat. Coba lagi.',
        })
        isSearchingMap.value = false
        return
      }

      const lat = parseFloat(payload.value.latitude)
      const lng = parseFloat(payload.value.longitude)

      // Validasi 1: Cek apakah input adalah angka
      if (isNaN(lat) || isNaN(lng)) {
        notification.warn({
          message: 'Koordinat Tidak Valid',
          description: 'Mohon masukkan nilai Latitude dan Longitude yang benar.',
        })
        isSearchingMap.value = false
        return
      }

      // --- TAMBAHAN PENTING: VALIDASI JANGKAUAN ---
      // Validasi 2: Cek apakah nilai berada dalam rentang geografis yang benar
      if (lat < -90 || lat > 90) {
        notification.warn({
          message: 'Latitude Tidak Valid',
          description: 'Nilai Latitude harus berada di antara -90 dan 90.',
        })
        isSearchingMap.value = false
        return
      }
      if (lng < -180 || lng > 180) {
        notification.warn({
          message: 'Longitude Tidak Valid',
          description: 'Nilai Longitude harus berada di antara -180 dan 180.',
        })
        isSearchingMap.value = false
        return
      }
      // ---------------------------------------------

      // Log nilai yang akan digunakan, untuk memastikan nilainya benar
      console.log(`Nilai yang akan digunakan -> Latitude: ${lat}, Longitude: ${lng}`)

      try {
        setMarker(lat, lng)
        map.setView([lat, lng], 16)

        // Anda bisa uncomment lagi bagian fetch API sekarang
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=id`,
        )
        const data = await response.json()
        if (data && data.display_name) {
          payload.value.address = data.display_name
        } else {
          payload.value.address = `Koordinat: ${lat}, ${lng}`
        }
      } catch (error) {
        console.error('TERJADI ERROR saat interaksi dengan peta:', error)
        notification.error({
          message: 'Gagal Memproses Koordinat',
          description: 'Terjadi kesalahan saat menampilkan lokasi di peta.',
        })
      } finally {
        isSearchingMap.value = false
      }
    }

    const clearPayload = () => {
      payload.value = {
        customerSign: '',
        name: '',
        email: '',
        mobileNumber: '',
        officeNumber: '',
        PIC: '',
        address: '',
        latitude: null,
        longitude: null,
        organizationId: '',
        provinsi: '',
      }
      if (marker) {
        map.removeLayer(marker)
        marker = null
      }
      map.setView([-6.2088, 106.8456], 13)
    }

    const fetchProvinsi = value => {
      if (value) {
        filteredProvinces.value = provinces.value.filter(prov =>
          prov.toLowerCase().includes(value.toLowerCase()),
        )
      } else {
        filteredProvinces.value = [...provinces.value]
      }
    }

    // Fungsi validasi baru
    const validatePayload = () => {
      let isValid = true
      const missingFields = []

      for (const field in requiredFields) {
        const value = payload.value[field]

        // Khusus untuk latitude/longitude, cek jika address ada tapi lat/lng kosong
        if (
          (field === 'latitude' || field === 'longitude') &&
          payload.value.address &&
          (value === null || value === '')
        ) {
          missingFields.push(requiredFields[field])
          isValid = false
        }
        // Untuk field lain, cukup cek apakah nilainya kosong (string kosong, null, undefined, 0 (jika 0 dianggap kosong))
        else if (
          value === null ||
          value === '' ||
          (typeof value === 'string' && value.trim() === '')
        ) {
          // Abaikan officeNumber jika tidak wajib
          if (field === 'officeNumber') {
            continue
          }
          // Abaikan lat/lng jika address kosong (karena tidak wajib isi peta)
          if ((field === 'latitude' || field === 'longitude') && !payload.value.address) {
            continue
          }

          missingFields.push(requiredFields[field])
          isValid = false
        }
      }

      if (!isValid) {
        notification.error({
          message: 'Data belum lengkap',
          description: `Mohon lengkapi data berikut: ${missingFields.join(', ')}.`,
          duration: 4.5, // Durasi notifikasi agar cukup terbaca
        })
      }
      return isValid
    }

    const submitPayload = async () => {
      if (!validatePayload()) {
        return // Hentikan proses jika validasi gagal
      }
      // Logika submit tidak perlu diubah karena payload sudah benar
      const data = await postCustomers(payload.value)
      if (data) {
        notification.success({
          message: 'Berhasil Submit',
          description: 'Data Customer Berhasil Dibuat',
        })
        router.push('/customers')
      } else {
        notification.error({ message: 'Server Error', description: 'Internal Server Error' })
      }
    }

    return {
      searchCoordinatesOnMap,
      payload,
      clearPayload,
      submitPayload,
      searchAddressOnMap,
      organizationList,
      filteredProvinces,
      fetchProvinsi,
    }
  },
}
</script>

<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-subtitle {
  font-size: 1.3rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-label {
  font-size: 1rem;
  color: $text;
  font-weight: 400;
  margin-bottom: 10px;
}

.th-upload-wrapper {
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;

    .ant-upload {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
